import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgbdProgressCircle} from './progress-circle';

export {NgbdProgressCircle} from './progress-circle';

@NgModule({declarations: [NgbdProgressCircle], exports: [NgbdProgressCircle], imports: [CommonModule]})
export class NgbdProgressCircleModule {
}
